import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { AuthTokenEncrypted } from "../shared/models/users/auth-token-encrypted";
import { RegisterAsIndividual } from "../shared/models/users/register-as-individual";
import { UserFullDetails } from "../shared/models/users/user-full-details";
import { SearchResult } from "../shared/models/general/search-result";

import { UserFiaPins } from "../shared/models/users/user-fia-pins";

@Injectable({
  providedIn: "root",
})
export class UserService {
  env = environment;
  apiUrl = this.env.apiurl + "platform/users/";

  constructor(
    private http: HttpClient,
    public router: Router,
  ) {}

  public RegisterAsIndevidual(
    model: RegisterAsIndividual,
  ): Observable<AuthTokenEncrypted> {
    return this.http
      .post<AuthTokenEncrypted>(this.apiUrl + "register-as-individual", model)
      .pipe(map((data) => new AuthTokenEncrypted().deserialize(data)));
  }

  public ConfirmRegistration(Token: string): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + "confirm-registration/" + Token, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200 || res.status == 204) {
              return;
            }
          }
        }),
      );
  }

  public GetUserDetails(Id: number): Observable<any> {
    return this.http
      .get<UserFullDetails>(`${this.apiUrl}full-details/${Id}/false`, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return new UserFullDetails().deserialize(res.body);
            }
          }
        }),
      );
  }

  public GetUsersFiaPins(
    userId: number,
    excludeExpiredPins: boolean = true,
  ): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}fia-pins/${userId}/${excludeExpiredPins}`, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: any) =>
                new UserFiaPins().deserialize(data),
              );
            }
          }
        }),
      );
  }

  public GetFullDetailsByEntity(Entity: number, Id: number): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + "full-details/entity-type/" + Entity + "/" + Id, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: any) =>
                new UserFullDetails().deserialize(data),
              );
            }
          }
        }),
      );
  }

  public ValidateToken(Token: string): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + "validate-pin/" + Token, { observe: "response" })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return new SearchResult().deserialize(res.body);
            }
          }
        }),
      );
  }

  public UserProfileUpdate(userFullDetails: UserFullDetails): Observable<any> {
    return this.http
      .put<any>(this.apiUrl + "profile", userFullDetails, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return;
            }
          }
        }),
      );
  }

  public UserExists(emailAdd: string): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + "check-user-email/" + emailAdd, {
        observe: "response",
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return 200;
            }
          }
        }),
      );
  }
}
